// extracted by mini-css-extract-plugin
export var addButton = "_ol-0";
export var border = "_ol-8";
export var check = "_ol-h";
export var danger = "_ol-6";
export var dropdownContainer = "_ol-1";
export var editModalBody = "_ol-j";
export var footerContainer = "_ol-i";
export var fullWidth = "_ol-a";
export var hide = "_ol-9";
export var icon = "_ol-3";
export var input = "_ol-7";
export var inputFlex = "_ol-b";
export var inputWrapper = "_ol-c";
export var manualFocus = "_ol-5";
export var optionButton = "_ol-4";
export var pillWrapper = "_ol-e";
export var pointer = "_ol-2";
export var showOverflow = "_ol-f";
export var tagsFlex = "_ol-d";
export var xButton = "_ol-g";